import React, { useState } from 'react';
import './Settings.css';

function Toggle({ value, onChange }) {
  return (
    <button className={`toggle ${value ? 'on' : ''}`} onClick={() => onChange(!value)}>
      <span className="toggle-thumb" />
    </button>
  );
}

export default function Settings() {
  const [settings, setSettings] = useState({
    emailNotifications: true,
    slackAlerts:        false,
    reEnrollOff:        true,
    autoTasks:          true,
    dailyDigest:        true,
    escalationAlerts:   true,
    twoFactor:          false,
    apiAccess:          true,
  });

  const set = key => val => setSettings(prev => ({ ...prev, [key]: val }));

  const Section = ({ title, children }) => (
    <div className="settings-section">
      <h3 className="settings-section-title">{title}</h3>
      <div className="settings-card">{children}</div>
    </div>
  );

  const Row = ({ label, desc, settingKey }) => (
    <div className="settings-row">
      <div className="settings-row-text">
        <div className="settings-row-label">{label}</div>
        {desc && <div className="settings-row-desc">{desc}</div>}
      </div>
      <Toggle value={settings[settingKey]} onChange={set(settingKey)} />
    </div>
  );

  return (
    <div className="settings-page">
      <Section title="Notifications">
        <Row label="Email notifications" desc="Receive email alerts for key events and activations" settingKey="emailNotifications" />
        <Row label="Slack alerts" desc="Send notifications to your connected Slack workspace" settingKey="slackAlerts" />
        <Row label="Daily digest" desc="Receive a daily summary email each morning" settingKey="dailyDigest" />
        <Row label="Escalation alerts" desc="Notify rep when a club hasn't responded after 7 days" settingKey="escalationAlerts" />
      </Section>

      <Section title="Workflows">
        <Row label="Re-enroll off (default)" desc="Contacts can only go through each workflow once by default" settingKey="reEnrollOff" />
        <Row label="Auto-generate tasks" desc="Automatically create tasks for reps when contacts hit workflow steps" settingKey="autoTasks" />
      </Section>

      <Section title="Security">
        <Row label="Two-factor authentication" desc="Require OTP verification on every login" settingKey="twoFactor" />
        <Row label="API access" desc="Allow external services to connect via the TransferExpo API" settingKey="apiAccess" />
      </Section>

      <Section title="Danger zone">
        <div className="danger-actions">
          <div className="danger-row">
            <div>
              <div className="danger-label">Clear all workflow enrollments</div>
              <div className="danger-desc">Remove all contacts from active workflows. This cannot be undone.</div>
            </div>
            <button className="btn btn-danger">Clear enrollments</button>
          </div>
          <div className="danger-row">
            <div>
              <div className="danger-label">Reset CRM data</div>
              <div className="danger-desc">Delete all contacts, deals and activity data permanently.</div>
            </div>
            <button className="btn btn-danger">Reset data</button>
          </div>
        </div>
      </Section>
    </div>
  );
}
